export const CONFIGURATION_REQUEST = 'CONFIGURATION_REQUEST';
export const CONFIGURATION_UPDATE = 'CONFIGURATION_UPDATE';
export const HEARTBEAT = 'HEARTBEAT';
export const WATCHDOG_LOG_REQUEST = 'WATCHDOG_LOG_REQUEST';
